import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import MenuItem from '@material-ui/core/MenuItem'
import Popover from '@material-ui/core/Popover'
import { AppTheme } from '../../../../styles/AppTheme'
import { chatbotNodeIcon } from './ChatbotNodeHeader'
import { NODE_PALETTE } from './chatbotGraph'

export function ChatbotAddNodeMenu(props) {
  const open = !!props.open
  const pos = props.anchorPosition || { top: 0, left: 0 }
  const onClose = props.onClose
  const onSelect = props.onSelect

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={pos}
      getContentAnchorEl={null}
      elevation={0}
      marginThreshold={12}
      PaperProps={{
        role: 'dialog',
        'aria-label': 'Add a step',
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
        },
      }}
      classes={{ paper: css(Styles.popover) }}
    >
      <div className={css(Styles.inner)}>
        <div className={css(Styles.title)}>Add a step</div>
        {(props.palette || NODE_PALETTE || []).map(item => (
          <MenuItem
            key={item.type}
            onClick={() => onSelect && onSelect(item.type)}
            className={css(Styles.menuItem)}
          >
            <i className={'material-icons-outlined ' + css(Styles.menuIcon)}>{chatbotNodeIcon(item.type)}</i>
            <span>{item.label}</span>
          </MenuItem>
        ))}
      </div>
    </Popover>
  )
}

const Styles = StyleSheet.create({
  popover: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    overflow: 'visible',
  },
  inner: {
    padding: 4,
    minWidth: 180,
    boxShadow: '3px 6px 43px rgba(0, 0, 0, 0.05)',
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: 12,
    backgroundColor: AppTheme.secondaryBg,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    color: '#222222',
    padding: '8px 10px 4px',
    lineHeight: '20px',
  },
  menuItem: {
    fontSize: 13,
    color: '#6E84A3',
    padding: '6px 10px',
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  menuIcon: {
    fontSize: 18,
    color: '#6B7280',
  },
})
